export default "<input class=\"fileInput\" type=\"file\" (change)=\"onFileSelected()\" #fileInput>"